import reduxApi from 'redux-api';
import customFetch from 'api/axios';
import { API_URL } from 'constants/config';

// Example
export default reduxApi({
  signin: {
    url: `${API_URL}/auth/login`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: {},
        headers: params
      };
    }
  },
  logout: {
    url: `${API_URL}/auth/logout`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: {}
      };
    }
  },
  logoutSSO: {
    url: `${API_URL}/logout`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  sendCode: {
    url: `${API_URL}/auth/sendEmail`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  changePassword: {
    url: `${API_URL}/auth/changePassword`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  updateSession: {
    url: `${API_URL}/auth/updateSession`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: {}
      };
    }
  },
  resetPassword: {
    url: `${API_URL}/auth/resetPassword`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  confirmCode: {
    url: `${API_URL}/auth/confirmCode`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  postSwitchRole: {
    url: `${API_URL}/auth/switchRole`,
    options: (url, params, getState) => {
      return {
        method: 'POST',
        data: params
      };
    }
  },
  getInfoFromToken: {
    url: `${API_URL}/auth/me`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
  loginSSO: {
    url: `${API_URL}/sso/userinfo`,
    options: (url, _params, getState) => {
      return {
        method: 'GET',
        params: _params
      };
    }
  },
}).use('fetch', customFetch);



// WEBPACK FOOTER //
// ./src/api/users.js